import { useQuery } from '@tanstack/react-query';

import { statsApi } from '../stats.api';

import { StatsQueryParams } from './types';

export const useQueryStatsUptime = ({
  dateTo,
  fromUnitType,
  fromValue,
  aircraftsIdList = [],
}: StatsQueryParams) => {
  const enabled = ![fromUnitType, fromValue, dateTo].some(v => v === undefined);
  const dateToString = dateTo.toISOString();
  return useQuery({
    queryKey: [
      'StatsUptime',
      fromValue,
      fromUnitType,
      dateToString,
      aircraftsIdList,
    ],
    queryFn: async () =>
      statsApi.getUptime({
        dateTo,
        fromValue,
        fromUnitType,
        aircraftsIdList,
      }),
    select: data => data,
    enabled,
  });
};
